const theme = {
  light: {
    dark: false,
    variables: {}, 
    colors: {
      primary: '#a3d95b',
      secundary: '#f6f0bc',
      auxiliary: '#1f0310',
      lighterSuccess: '#14A44D',
      lighterError: '#DC4C64',
    },
   },
  dark: {
   dark: true,
   variables: {}, 
   colors: {},
  },
}
export default theme;